import backend from "../utils/backend";
import { GET_LATEST_STORIES, GET_LATEST_STORIES_SUCCESS, GET_LATEST_STORIES_ERROR } from "../constants/actionTypes";

export var getLatestStories = function getLatestStories() {
  return function (dispatch, getState) {
    var state = getState();
    if (state.latestStories && state.latestStories.isLoading) {
      // Don't dispatch more requests for latest stories while API requests are still pending.
      return;
    }

    dispatch({
      type: GET_LATEST_STORIES
    });

    return backend.request({
      method: "GET",
      url: "/most-recent/"
    }).then(function (response) {
      dispatch({
        type: GET_LATEST_STORIES_SUCCESS,
        payload: response.data.results
      });
    }).catch(function (err) {
      dispatch({
        type: GET_LATEST_STORIES_ERROR,
        payload: err
      });
    });
  };
};


// WEBPACK FOOTER //
// ./src/actions/latestStories.js